import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/users/counters', options)
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))
}

export default { get }
